// 错误页面国际化 - 中文
export default {
  // 404页面
  404: {
    title: '页面未找到',
    message: '抱歉，您访问的页面不存在或已被删除。',
    goHome: '返回首页',
    backPage: '返回上页',
    suggestions: '您可能想要访问',
    suggestedLinks: {
      dashboard: '仪表盘',
      orderManagement: '订单管理',
      companyProfile: '公司资料',
      basicData: '基础资料'
    }
  },

  // 403页面
  403: {
    title: '访问被拒绝',
    message: '抱歉，您没有权限访问此页面。',
    goHome: '返回首页',
    backPage: '返回上页',
    contactAdmin: '联系管理员'
  },

  // 500页面
  500: {
    title: '服务器错误',
    message: '服务器发生内部错误，请稍后重试。',
    goHome: '返回首页',
    backPage: '返回上页',
    refresh: '刷新页面',
    reportProblem: '报告问题'
  },

  // 网络错误
  network: {
    title: '网络连接失败',
    message: '请检查您的网络连接并重试。',
    retry: '重新连接',
    checkNetwork: '检查网络'
  },

  // 通用错误
  common: {
    unknownError: '未知错误',
    operationFailed: '操作失败',
    pleaseTryAgain: '请稍后重试',
    http401: '登录已过期，请重新登录',
    http403: '权限不足，无法访问',
    http404: '请求的资源不存在',
    http5xx: '服务器错误，请稍后重试'
  },
  // 业务错误
  price: {
    duplicate: '已存在完全一致的运价记录，请勿重复操作'
  }
}
